module.exports = require('./helpers/bundle-url').getBundleURL('1hhWI') + "logo-dark.eefe0b7f.svg";